import { Component, OnInit, ViewChild, Input, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { Tool, Company, UserType, User } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SortDirection, SharedDataService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, combineLatest, Subscription } from 'rxjs';
import { ToolEditComponent } from '../tool-edit/tool-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-tool-list',
	templateUrl: './tool-list.component.html',
	styleUrls: ['./tool-list.component.scss']
})
export class ToolListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: Tool[];

	advancedSearch: Search = new Search('tool', 'name', 'tool');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	companyid: number;

	loggedUser: User;
	subcription: Subscription;

	constructor(
		private toolService: CrudService<Tool>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService
	) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			if (this.loggedUser.utype === UserType.company) {
				this.companyid = this.loggedUser.companyid;
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}

	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.companyid) {
			this.advancedSearch.addSimpleFilter('companyid', this.companyid);
		}

		const datarequest = this.toolService.searchEntities(Tool, 'tool', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.toolService.countEntities(Tool, 'tool', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any) {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.router.navigate([`/company/tool/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			}
		}
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: Tool, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-tool-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.toolService.deleteEntity(Tool, 'tool', row).subscribe(() => {
					this.translateService.get(['labels.tool-deleted', 'labels.tools']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.tool-deleted'], messages['labels.tools']);
						this.load();
					});
				});
			}
		});
	}


	edit(toolid?: number) {
		const modal = this.modalService.open(ToolEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.companyid = this.companyid;
		if (toolid) {
			modal.componentInstance.load(toolid);
		}
		modal.result.then((newItem: Tool) => {
			this.load();
		}).catch(() => { });
	}

}
